import cx from 'classnames'
import {
  Primary,
  Text,
  TextFontSizes,
  TextFontWeights,
  TextLineHeights,
} from '@cinch-labs/design-system'
import styles from './ready-to-get-car-finance.module.css'
import { ReadyToGetCarFinanceText } from '../../types/locales'
import { Wrapper } from '@cinch-nx/shared-ui'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import { searchAllCarsClick } from '../../tracking/tracking-events'

interface ReadyToGetCarFinanceProps {
  i18n: ReadyToGetCarFinanceText
  className?: string
  children?: React.ReactNode
}

function ReadyToGetCarFinance({ i18n, className }: ReadyToGetCarFinanceProps) {
  const { trackEvent } = useAnalytics()

  return (
    <article className={cx(styles.readyToGetCarFinance, className)}>
      <Wrapper>
        <Text
          element="h2"
          fontSize={TextFontSizes['4xl']}
          fontWeight={TextFontWeights.bold}
          lineHeight={TextLineHeights.display}
          className={styles.readyToGetCarFinanceMainTitle}
        >
          {i18n.title}
        </Text>
        <Text fontSize={TextFontSizes.s} fontWeight={TextFontWeights.book}>
          {i18n.text}
        </Text>
        <div className={styles.readyToGetCarFinanceButton}>
          <Primary
            data-testid="search-all-cars-button"
            element={'a'}
            href="/used-cars"
            onClick={() => trackEvent(searchAllCarsClick())}
          >
            Search all cars
          </Primary>
        </div>
      </Wrapper>
    </article>
  )
}

export default ReadyToGetCarFinance
